var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('apexchart',{attrs:{"width":"100%","height":"250","type":"bar","options":_vm.generateOptions(),"series":_vm.series}}),(!_vm.categories.length)?_c('p',{staticClass:"has-text-warning has-text-centered is-italic has-text-weight-medium"},[_vm._v(" Keine Daten vorhanden. ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }